import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import SignIn from './Pages/Auth/Login/signin';
import Home from './Pages/Home';
import UnitHome from './Pages/Unit/unitHome';

import { ToastContainer } from 'react-toastify';
import { GlobalProvider } from './GlobalContext';
import 'react-toastify/dist/ReactToastify.css';

import UserProfile from './Pages/TabContent/userProfile';
import AgentList from './Pages/TabContent/MyAgent/agentList';
import CreateAgentAccount from './Pages/TabContent/MyAgent/createAgentAccont';
import EditAgent from './Pages/TabContent/MyAgent/editAgentAccount';
import CompanyList from './Pages/TabContent/MyCompany/companyList';
import CreateCompany from './Pages/TabContent/MyCompany/createCompany';
import EditCompany from './Pages/TabContent/MyCompany/editCompany';
import GroupList from './Pages/TabContent/MyGroup/groupList';
import CreateGroup from './Pages/TabContent/MyGroup/createGroups';
import EditGroup from './Pages/TabContent/MyGroup/editGroups';
import AddUsers from './Pages/TabContent/MyGroup/addUsers';
import UserManagement from './Pages/TabContent/MyGroup/userManagement';
import UserList from './Pages/TabContent/MyUser/userList';
import CreateUser from './Pages/TabContent/MyUser/createUser';
import EditUser from './Pages/TabContent/MyUser/editUser';
import FunctionCardRecord from './Pages/TabContent/functionCardRecord';
import SystemAnnoucement from './Pages/TabContent/systemAnnoucement';
import InventoryList from './Pages/TabContent/MyInventory/inventoryList';
import Invoice from './Pages/TabContent/MyInventory/invoice';
import CreateProduct from './Pages/TabContent/MyInventory/createProduct';
import ProductList from './Pages/TabContent/MyInventory/productList';
import EditProduct from './Pages/TabContent/MyInventory/editProduct';
import DebtorsList from './Pages/TabContent/MyInventory/debtorsList';
import CreateRent from './Pages/TabContent/MyInventory/createRent';
import ManageSOA from './Pages/TabContent/MyInventory/manageSOA';

import UnitUserProfile from './Pages/Unit/UnitTabContent/unitUserProfile';
import UnitCreateGroup from './Pages/Unit/UnitTabContent/MyGroup/unitCreateGroups';
import UnitGroupList from './Pages/Unit/UnitTabContent/MyGroup/unitGroupList';
import UnitAddUsers from './Pages/Unit/UnitTabContent/MyGroup/unitAddUsers';
import UnitUserManagement from './Pages/Unit/UnitTabContent/MyUser/unitUserManagement';
import UnitEditGroup from './Pages/Unit/UnitTabContent/MyUser/unitEditGroup';
import UnitUserList from './Pages/Unit/UnitTabContent/MyUser/unitUserList';
import UnitRecords from './Pages/Unit/UnitTabContent/Records/unitRecords';
import UnitSOSRecords from './Pages/Unit/UnitTabContent/SOSRecords/unitsosRecord';
import UnitCurrentOverrunRecord from './Pages/Unit/UnitTabContent/CrossborderRecord/unitCurrentOverrunRecord';
import UnitHistoryTransgresses from './Pages/Unit/UnitTabContent/CrossborderRecord/unitHistoryTransgresses';
import UnitCreateBounding from './Pages/Unit/UnitTabContent/Bounding/unitCreateBounding';
import UnitBoundingList from './Pages/Unit/UnitTabContent/Bounding/unitBoundingList';

function App() {
  return (<>

    <GlobalProvider>
      <Router>
        <ToastContainer />
        <Routes>
          <Route exact path='/' element={<SignIn/>}/>
          <Route element={<Home />}>
            <Route path='/userprofile' element={<UserProfile />} />
            <Route path='/agentlist' element={<AgentList />} />
            <Route path='/newagent' element={<CreateAgentAccount />} />
            <Route path='/editagent/:agentId' element={<EditAgent />} />
            <Route path='/companylist' element={<CompanyList />} />
            <Route path='/newcompany' element={<CreateCompany />} />
            <Route path='/editcompany/:companyId' element={<EditCompany />} />
            <Route path='/grouplist' element={<GroupList />} />
            <Route path='/newgroup' element={<CreateGroup />} />
            <Route path='/editgroup/:groupId' element={<EditGroup />} />
            <Route path='/addusers/:groupId' element={<AddUsers />} />
            <Route path='/usermanagement/:groupId' element={<UserManagement />} />
            <Route path='/userlist' element={<UserList />} />
            <Route path='/newuser' element={<CreateUser />} />
            <Route path='/editstaff/:staffId' element={<EditUser />} />
            <Route path='/functioncardrecord' element={<FunctionCardRecord />} />
            <Route path='/systemannoucement' element={<SystemAnnoucement />} />
            <Route path='/inventorylist' element={<InventoryList />} />
            <Route path='/invoice' element={<Invoice />} />
            <Route path='/newproduct' element={<CreateProduct/>} />
            <Route path='/manageproduct' element={<ProductList/>} />
            <Route path='/editproduct/:productId' element={<EditProduct/>} />
            <Route path='/debtorslist' element={<DebtorsList/>} />
            <Route path='/newrent' element={<CreateRent/>} />
            <Route path='/managesoa' element={<ManageSOA/>} />
          </Route>
          <Route element={<UnitHome />}>
            <Route path='/unituserprofile' element={<UnitUserProfile />} />
            <Route path='/unitcreategroup' element={<UnitCreateGroup />} />
            <Route path='/unitgrouplist' element={<UnitGroupList />} />
            <Route path='/uniteditgroup/:groupId' element={<UnitEditGroup />} />
            <Route path='/unitaddusers/:groupId' element={<UnitAddUsers />} />
            <Route path='/unitusermanagement/:groupId' element={<UnitUserManagement />} />
            <Route path='/unituserlist' element={<UnitUserList />} />
            <Route path='/unitrecords' element={<UnitRecords />} />
            <Route path='/unitsosrecord' element={<UnitSOSRecords />} />
            <Route path='/unitcurrentoverrunrecord' element={<UnitCurrentOverrunRecord />} />
            <Route path='/unithistorytransgresses' element={<UnitHistoryTransgresses />} />
            <Route path='/unitcretebounding' element={<UnitCreateBounding />} />
            <Route path='/unitboundinglist' element={<UnitBoundingList />} />
          </Route>
        </Routes>
      </Router>
    </GlobalProvider>
  </>
  );
}

export default App;
